import { css } from "@emotion/css";
import { ExternalLink } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import React from "react";
import ArgoCDInstancesHelpImage from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/Areas/Infrastructure/components/ArgoCDInstancesHelpImage.svg";
import { LearnMoreResources, OverviewContainer, OverviewHighlightText, TopicsContainer } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonViews";
import ImageWithPlaceholder from "~/components/GettingStarted/ImageWithPlaceholder/ImageWithPlaceholder";
const styles = {
    imgContainer: css({
        marginTop: space[16],
    }),
    fixImgWidth: css({
        "&&": {
            width: "100% !important",
        },
    }),
};
export const ArgoCDInstancesOverview = () => (<OverviewContainer>
        <OverviewHighlightText>
            <p>
                <ExternalLink href={"argo-cd-instances-docs"}>Argo CD instances</ExternalLink> let you combine your GitOps workflows with powerful deployment orchestration from Octopus.
            </p>
            <br />
            <p>To get started, install a gateway in your cluster and use annotations to map applications to projects, environments and tenants.</p>
            <br />
            <p>Then use the built-in Argo CD steps to update container images or generate manifests from templates.</p>
            <div className={styles.imgContainer}>
                <ImageWithPlaceholder src={ArgoCDInstancesHelpImage} alt={"Argo CD in Octopus"} className={styles.fixImgWidth}/>
            </div>
        </OverviewHighlightText>
    </OverviewContainer>);
export const ArgoCDInstancesTopics = () => (<TopicsContainer>
        <LearnMoreResources>
            <div>
                <ExternalLink href={"argo-cd-integration-docs"}>Argo CD in Octopus</ExternalLink>
            </div>
            <div>
                <ExternalLink href={"argo-cd-getting-started"}>Getting started</ExternalLink>
            </div>
            <div>
                <ExternalLink href={"argo-cd-steps-docs"}>Deployment steps</ExternalLink>
            </div>
            <div>
                <ExternalLink href={"argo-cd-annotations-docs"}>Annotations</ExternalLink>
            </div>
            <div>
                <ExternalLink href={"argo-cd-supported-use-cases"}>Supported use cases</ExternalLink>
            </div>
        </LearnMoreResources>
    </TopicsContainer>);
